import {Component, Input, OnInit} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';
import {AuthService} from '../../../core/services';
import {PaymentService} from '../../../core/services/payment.service';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.css']
})
export class BillingComponent implements OnInit {
  @Input() jobId: string;
  public url = environment.api_url + '/v2/api/employer/payment/single';
  public user: any;
  public safeUrl;
  public loading = true;
  constructor(
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    private paymentService: PaymentService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit() {
    this.spinner.show('page');
    this.loading = true;
    this.paymentService.getPaymentPage(this.jobId).subscribe( data => {
       
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.url);
      this.spinner.hide('page');
      this.loading = false;
    });
  }

}
